import { render, staticRenderFns } from "./data76.vue?vue&type=template&id=2b7ac93e&scoped=true"
import script from "./data76.vue?vue&type=script&lang=js"
export * from "./data76.vue?vue&type=script&lang=js"
import style1 from "./data76.vue?vue&type=style&index=1&id=2b7ac93e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ac93e",
  null
  
)

export default component.exports